export default "__VITE_ASSET__DjYd3PJo__"